import React, { useCallback } from "react";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import { HVH_COLORS } from "../../config/palette";
import { IconInformationFill } from "@amzn/stencil-react-components/icons";
import { useHistory } from "react-router-dom";
import useArb from "../../hooks/use-arb";

interface CSSHeaderProps {
  cssURLWithoutScheduleId?: string;
}

const linkStyle = {
  cursor: "pointer",
};

export const CSSHeader = ({ cssURLWithoutScheduleId }: CSSHeaderProps) => {
  if (!cssURLWithoutScheduleId) {
    return null;
  }
  const bundle = useArb("HVHChecklistPantherResource");

  const nextStep = bundle.getMessage("Checklist-CSS-Continue");
  const selectSchedule = bundle.getMessage("Checklist-CSS-Select");
  const history = useHistory();
  const navigateToCSSUrl = useCallback(() => {
    const url = cssURLWithoutScheduleId;
    url.startsWith("http") ? window.location.assign(url) : history.push(url);
  }, [history]);

  return (
    <Col backgroundColor={HVH_COLORS.NEUTRAL_05} padding="1rem" alignItems={"center"}>
      <Row padding="0.2rem">
        <Col padding="0.2rem">
          <IconInformationFill color={HVH_COLORS.NEUTRAL_70} />
        </Col>
        <Col padding="0.2rem">
          <Text fontSize="T200">{nextStep}</Text>
        </Col>
        <Col padding="0.2rem">
          <Link textDecoration="none" style={linkStyle} onClick={navigateToCSSUrl}>
            <Text fontSize="T200">{selectSchedule}</Text>
          </Link>
        </Col>
      </Row>
    </Col>
  );
};
